<template>
  <div>
    <CRow class="mt-3">
      <CCol sm="12">
        <CButton
          color="primary" ref="refreshBtn"
          v-c-tooltip.hover="'Tải lại'"
          class="btn-action-primary"
          @click="changeTab()"
          style="float: right;">
          <i class="fa fa-refresh"></i>&nbsp;&nbsp;Tải lại
        </CButton>
        <CTabs variant="pills" :active-tab="activeTab.data.model" @update:activeTab="changeTab">
          <CTab title="Tài khoản đang online">
            <CCard class="content-fade-in mt-3p5">
              <CCardBody>
                <BaseTable
                  :options="mainTable.options"
                  :slots="mainTable.slots"
                  :dataSource="mainTable.dataSource"
                  ref="mainTable">
                  <template #index="{index}">
                    <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
                  </template>
                  <template #key="{item}">
                    <td>
                      <span style="font-weight: 550;">{{ item.key }}</span>
                    </td>
                  </template>
                  <template #values="{item}">
                    <td>
                      <template v-for="each in item.values ">
                        <span style="font-weight: 550;">{{ each }}</span>
                        <br/>
                      </template>
                    </td>
                  </template>
                  <template #action="{item}">
                    <td class="action-btn-group">
                      <div class="action-btn-wrapper">
                        <CButton
                          color="danger"
                          variant="outline"
                          class="ml-1"
                          square
                          size="sm"
                          v-c-tooltip.hover="'Xóa'"
                          @click="setupSelectOneAction('delete_one', item.key)">
                          <CIcon name="cil-trash"/>
                        </CButton>
                      </div>
                    </td>
                  </template>
                </BaseTable>
              </CCardBody>
            </CCard>
          </CTab>
          <CTab title="Ping Kết nối lại Livestream">
            <CCard class="content-fade-in mt-3p5">
              <CCardBody>
                <BaseTable
                  :options="mainTablePingReconnect.options"
                  :slots="mainTablePingReconnect.slots"
                  :dataSource="mainTablePingReconnect.dataSource"
                  ref="mainTablePingReconnect">
                  <template #index="{index}">
                    <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
                  </template>
                  <template #key="{item}">
                    <td>
                      <span style="font-weight: 550;">{{ item.key }}</span>
                    </td>
                  </template>
                  <template #values="{item}">
                    <td>
                      <template v-for="each in item.values ">
                        <span style="font-weight: 550;">{{ each }}</span>
                        <br/>
                      </template>
                    </td>
                  </template>
                  <template #action="{item}">
                    <td class="action-btn-group">
                      <div class="action-btn-wrapper">
                        <CButton
                          color="danger"
                          variant="outline"
                          class="ml-1"
                          square
                          size="sm"
                          v-c-tooltip.hover="'Xóa'"
                          @click="setupSelectOneAction('delete_one', item.key)">
                          <CIcon name="cil-trash"/>
                        </CButton>
                      </div>
                    </td>
                  </template>
                </BaseTable>
              </CCardBody>
            </CCard>
          </CTab>
          <CTab title="Ping Kiểm tra trạng thái Livestream">
            <CCard class="content-fade-in mt-3p5">
              <CCardBody>
                <BaseTable
                  :options="mainTablePingCheckStatus.options"
                  :slots="mainTablePingCheckStatus.slots"
                  :dataSource="mainTablePingCheckStatus.dataSource"
                  ref="mainTablePingCheckStatus">
                  <template #index="{index}">
                    <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
                  </template>
                  <template #key="{item}">
                    <td>
                      <span style="font-weight: 550;">{{ item.key }}</span>
                    </td>
                  </template>
                  <template #values="{item}">
                    <td>
                      <template v-for="each in item.values ">
                        <span style="font-weight: 550;">{{ each }}</span>
                        <br/>
                      </template>
                    </td>
                  </template>
                  <template #action="{item}">
                    <td class="action-btn-group">
                      <div class="action-btn-wrapper">
                        <CButton
                          color="danger"
                          variant="outline"
                          class="ml-1"
                          square
                          size="sm"
                          v-c-tooltip.hover="'Xóa'"
                          @click="setupSelectOneAction('delete_one', item.key)">
                          <CIcon name="cil-trash"/>
                        </CButton>
                      </div>
                    </td>
                  </template>
                </BaseTable>
              </CCardBody>
            </CCard>
          </CTab>
        </CTabs>
      </CCol>
    </CRow>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";

export default {
  name: "CacheList",
  components: {BaseTable, ModalConfirm, BaseInput},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    var that = this;
    var actionTypeMapping = new Map();
    actionTypeMapping.set("delete_one", {
      url: "/cache/delete",
      isJsonContentType: false,
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "KEY",
          that.actionData.model.key
        );
      },
      dataSubmit: function () {
        return {
          key: that.actionData.model.key,
          type : that.activeTab.data.model
        };
      },
      successCallback: function () {
        that.showSuccessMsg({
          message: "Cập nhật tiến trình thành công"
        });
        that.changeTab();
      }
    });

    return {
      activeTab: {
        data: {
          model: 0,
          name: 'type'
        }
      },
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          key: null
        }
      },
      mainTable: {
        options: {
          noPaging: true,
          fields: [
            {key: "index", label: "STT"},
            {key: "key", label: "KEY"},
            {key: "values", label: "Values"},
            {key: "action", label: "Action"}
          ],
          slots: ["index", "key", "values", "action"]
        },
        dataSource: {
          url: "/cache/list",
          isJsonContentType: false,
          dataRef: function () {
            return that.$data;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
          btnCallAjaxs: function () {
            return [that.$refs.refreshBtn]
          },
          resultListAttrName: "results"
        }
      },
      mainTablePingReconnect: {
        options: {
          noPaging: true,
          fields: [
            {key: "index", label: "STT"},
            {key: "key", label: "KEY"},
            {key: "values", label: "Values"},
            {key: "action", label: "Action"}
          ],
          slots: ["index", "key", "values", "action"],
          lazyLoad: false
        },
        dataSource: {
          url: "/cache/list",
          isJsonContentType: false,
          dataRef: function () {
            return that.$data;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
          btnCallAjaxs: function () {
            return [that.$refs.refreshBtn]
          },
          resultListAttrName: "results"
        }
      },
      mainTablePingCheckStatus: {
        options: {
          noPaging: true,
          fields: [
            {key: "index", label: "STT"},
            {key: "key", label: "KEY"},
            {key: "values", label: "Values"},
            {key: "action", label: "Action"}
          ],
          slots: ["index", "key", "values", "action"],
          lazyLoad: false
        },
        dataSource: {
          url: "/cache/list",
          isJsonContentType: false,
          dataRef: function () {
            return that.$data;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
          btnCallAjaxs: function () {
            return [that.$refs.refreshBtn]
          },
          resultListAttrName: "results"
        }
      }
    };
  },
  methods: {
    setupSelectOneAction: function (actionTypeKey, key) {
      let actionData = this.actionData.model;
      actionData.key = key || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    loadDataMainTable: function () {
      this.$refs.mainTable.loadData();
    },
    setupThreadAction: function (actionTypeKey, threadSelectedId) {
      this.actionData.model.threadSelectedId = threadSelectedId || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    changeTab(tab) {
      if (tab) {
        this.activeTab.data.model = tab;
      }
      if (this.activeTab.data.model == 0) {
        this.$refs.mainTable.loadData();
      } else if (this.activeTab.data.model == 1) {
        this.$refs.mainTablePingReconnect.loadData();
      } else if (this.activeTab.data.model == 2) {
        this.$refs.mainTablePingCheckStatus.loadData();
      }
    }
  },
  computed: {},
  beforeCreate: function () {
  },
  created: function () {
  },
  mounted() {
  },
  watch: {}
};
</script>
<style scoped></style>
